/**
 * 模組頁面代碼 :
 * 頁面說明 : 登入帳號驗證元件
 * @module features/auth/AuthComponent.jsx
 */

// ----- import from npm modules -----
import {useNavigate, useLocation} from 'react-router-dom';

// ----- import from base components -----
import {React, PropTypes, BaseComponent, bindActionCreators, connect, withTranslation} from '../../components/BaseComponent';

// ----- import from local actions -----
import {authenticate} from '../../redux/actions/AuthActions';
import {fetchUserPermissions} from './../../redux/actions/AccessActions';

// ----- constants -----
const RESPONSE_OK = 200;

/**
 *
 */
class authComponent extends BaseComponent {
  /**
   *
   */
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      hasAccess: false,
    };
    this.handleAuth = this.handleAuth.bind(this);
  }

  /**
   *
   */
  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.handleAuth();
    }
  }

  /**
   *
   */
  componentDidMount() {
    this.handleAuth();
  }

  /**
   *
   */
  handleAuth(event) {
    if (event) {
      event.preventDefault();
    }
    this.props.auth().then((response) => {
      const statusCode = response.payload.code;
      this.setState({
        hasAccess: statusCode === RESPONSE_OK,
        loading: false,
      });
      if (statusCode === RESPONSE_OK) {
        // 取得使用者權限
        this.props.fetchUserPermissions().then(() => {
          // console.log('get user permissions done');
        });
      }
    });
  }

  /**
   *
   */
  render() {
    const {loading, hasAccess} = this.state;

    if (loading) {
      return <div>Loading...</div>;
    }

    if (!hasAccess) {
      return null;
    }

    return <>{this.props.children}</>;
  }
}

authComponent.propTypes = {
  auth: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired,
  children: PropTypes.node,
  location: PropTypes.object.isRequired,
};

authComponent.defaultProps = {
  children: null,
};

/**
 *
 */
function mapStateToProps(state) {
  return {};
}

/**
 *
 */
function mapDispatchToProps(dispatch) {
  return {
    auth: () => {
      return dispatch(authenticate());
    },
    fetchUserPermissions: () => {
      return dispatch(fetchUserPermissions()).then(() => {
        return Promise.resolve();
      });
    },
  };
}

const ConnectedAuth = connect(mapStateToProps, mapDispatchToProps)(authComponent);

/**
 *
 */
export default function AuthComponent(props) {
  const navigate = useNavigate();
  const location = useLocation();
  return <ConnectedAuth {...props} onNavigate={(path) => navigate(path)} location={location} />;
}
